import React from 'react';
import PropTypes from 'prop-types';
import {contentUtils, HTMLContent} from "mindsets-js-sdk";

function DnDDraggedItem(
    {
        is_preview,
        item,
        onRemove = () => {
        }
    }
) {
    function getDraggableStyle(default_style) {
        return {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0",
            minHeight: "50px",
            minWidth: "50px",
            borderRadius: "4px",
            ..._.get(item, 'draggable_style'),
            ...default_style
        }
    }

    function getContent() {
        const contentImage = _.get(item, 'content.image');
        const contentHtml = _.get(item, 'content.html');
        if (contentImage) {
            return (
                <img src={contentImage} alt={'DND option'}/>
            )
        } else if (contentHtml) {
            return <HTMLContent html_str={contentUtils.processStringContent(contentHtml)}/>;
        } else {
            return null;
        }
    }

    const showRemoveIcon = () => {
        if (!is_preview) {
            return (
                <i
                    className="dnd-answer-one-remove far fa-times-circle"
                    onClick={onRemove}
                >
                </i>
            );
        }
    }

    return (
        <div
            className="dnd-option-selected"
            style={getDraggableStyle({})}
        >
            {showRemoveIcon()}

            {getContent()}
        </div>
    )
}

DnDDraggedItem.propTypes = {
    is_preview: PropTypes.bool.isRequired,
    item: PropTypes.shape({
        content: PropTypes.shape({
            image: PropTypes.string,
            html: PropTypes.string
        }).isRequired,
        draggable_style: PropTypes.object
    }).isRequired,
    onRemove: PropTypes.func
}

export default DnDDraggedItem
